/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 14:23:24
 * @LastEditTime: 2021-04-22 15:56:27
 * @LastEditors: wangshengqiang
 * @Description: s
 */
export { default as withProps } from './withProps';
export { default as withQuery } from './withQuery';